import { useQuery } from '@apollo/client';

import Automation from '@components/automations/Automation';
import automationStyles from '@components/automations/Automation.module.css';
import HandleQuery from '@components/HandleQuery';
import ExpertPage from '@components/pageTypes/ExpertPage';
import { GetAutomationDocument, GetAutomationQuery, GetAutomationQueryVariables } from '@typing/Generated';

type Props = {
  automationId: string;
};

const ExpertAutomationPage = ({ automationId }: Props) => {
  const getAutomationQuery = useQuery<GetAutomationQuery, GetAutomationQueryVariables>(GetAutomationDocument, {
    variables: {
      id: automationId
    }
  });

  return (
    <ExpertPage
      containerClassName={automationStyles.pageContainer}
      contentClassName={automationStyles.pageContainer}
      helmetKey="pageTitles.expert.automation.show"
      imageName="map"
      titleKey="pages.expert.automation.title"
    >
      <HandleQuery query={getAutomationQuery}>{data => <Automation automation={data.automation} />}</HandleQuery>
    </ExpertPage>
  );
};

export default ExpertAutomationPage;
